
export function isFunction(func) {
  return Object.prototype.toString.call(func) === '[object Function]';
}

export function stringifyError(err, level) {
  void 0 === level && (level = 1);
  if (level >= 3) return 'stringifyError stack overflow';
  try {
      if (!err) return `<unknown error: ${{}.toString.call(err)}>`;
      if ('string' == typeof err) return err;
      if (err instanceof Error) {
          var stack = err && err.stack;
          var message = err && err.message;
          if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + '\n' + stack;
          if (stack) return stack;
          if (message) return message;
      }
      return err && err.toString && 'function' == typeof err.toString ? err.toString() : {}.toString.call(err);
  } catch (newErr) {
      return 'Error while stringifying error: ' + stringifyError(newErr, level + 1);
  }
}

export function waitForDocumentReady() {
  return new Promise((resolve) => {
      if(isDocumentReady() || isDocumentInteractive()) {
          resolve();
      } else {
          var interval = setInterval(() => {
              if(isDocumentReady() || isDocumentInteractive()) {
                  clearInterval(interval);
                  resolve();
              }
          }, 10);
      }
  });
}

export function waitForWindowReady() {
  return new Promise(resolve => {
      if (isDocumentReady()) {
          resolve();
      }

      window.addEventListener('load', () => resolve());
  });
}

export function isDocumentReady() {
  return Boolean(document.body) && 'complete' === document.readyState;
}
export function isDocumentInteractive() {
  return Boolean(document.body) && 'interactive' === document.readyState;
}
